<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ثبت برند</strong>

                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol sm="4">
                                <CInput
                                        v-model="name"
                                        horizontal
                                        label="نام برند"
                                        placeholder="نام برند"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CInput
                                        v-model="code"
                                        horizontal
                                        label="کد برند"
                                        placeholder="کد برند"
                                />
                            </CCol>

                        </CRow>



                    </CCardBody>
                    <CCardFooter>
                        <CButton
                                @click="login()"
                                type="submit" ref="submit_form" size="sm" color="primary">
                            <CIcon name="cil-check-circle"/>
                            ثبت برند
                        </CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

        <CCardBody>

            <CDataTable
                    :items="items"
                    :fields="fields"

                    :items-per-page="200"
                    hover
                    column-filter
                    sorter
                    pagination
            >
                <template #ردیف="{item}">

                    <td>
                        <p class="text-muted">{{item.row_id+1}}</p>

                    </td>

                </template>
                <template #نام="{item}">

                    <td>
                        <p class="text-muted">{{item.name}}</p>

                    </td>

                </template>

                <template #کد="{item}">

                    <td>
                        <p class="text-muted">{{item.code}}</p>

                    </td>

                </template>



                <template #عملیات="{item,index}">
                    <td class="py-2">
                        <CButton
                                color="primary"
                                variant="outline"
                                square
                                size="sm"
                                @click="editDetails(item)"
                        >ویرایش
                        </CButton>

                    </td>
                </template>


            </CDataTable>
        </CCardBody>


    </div>

</template>

<script>
    import axios from "axios";

    var items = [];



    export default {
        name: 'Login',
        data() {
            return {
                name: '',
                file: '',
                code: '',
                previewImage: '',
                file_header: '',
                previewImage_header: '',
                description: '',
                items: items.map((item, id) => {
                    return {...item, id}
                }),
                fields:[
                    {key: 'ردیف', _style: 'width:10%'},
                    {key: 'name',label:'نام', _style: 'width:10%'},
                    {key: 'کد', _style: 'width:20%'},

                    {key: 'عملیات', _style: 'width:40%;'},


                ],
                details: [],
                collapseDuration: 0,
                status_form: 0,
                language_rel_id: 0,
                language_id: 1,
            }
        }, mounted() {
            this.get_categories();
        }, watch: {
            '$route.params.cat_id': function (id) {
                this.get_categories();
            }
        },
        methods: {
            get_style(color) {
                return {
                    backgroundColor: color

                }
            },
            editDetails(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.name;
                this.code = item.code;

                this.status_form = item.cat_id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_categories() {
                var self = this;
                var formData = new FormData();
                formData.append('token',localStorage.getItem("token"));
                formData.append('cat_id',this.$route.params.cat_id);
                axios.post('/api/admin/get_brands' ,formData, {}).then(function (response) {
                    var content_cats = response.data;

                    self.items = content_cats.map((item, row_id) => {
                        return {...item, row_id}
                    });

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },


            login() {


                let self = this;
                const formData = new FormData()
                let url;
                if (this.status_form == 0) {
                    url = "/api/admin/add_brand";
                } else {
                    url = "/api/admin/edit_brand";
                    formData.append('brand_id', this.status_form)

                }


                formData.append('name', this.name);
                formData.append('code', this.code);

                formData.append('token',localStorage.getItem("token"));
                axios.post(url, formData, {}).then((res) => {
                    console.log(res)


                        url = "/api/admin/category";
                        self.name = '';
                        self.code = '';
                     self.status_form = 0;
                        // self.language_id = 1;
                        // self.language_rel_id = 0;
                        self.get_categories();


                }).catch(function (error) {
                        console.log(error);
                    });

            },

        }
    }


</script>
